import { AlertTriangle, Link, Clock, AtSign, FileWarning, Lock } from "lucide-react";

export const PhishingRedFlags = () => {
  const redFlags = [
    {
      icon: Clock,
      title: "Urgency & Pressure",
      description: "\"Act now or your account will be suspended!\" Legitimate companies rarely create artificial urgency.",
      examples: ["Account suspension threats", "Limited time offers", "Immediate action required"],
    },
    {
      icon: AtSign,
      title: "Suspicious Sender Address",
      description: "Look closely at the email domain. Attackers use lookalikes like amaz0n.com or microsoft-support.net.",
      examples: ["Misspelled domains", "Public email domains (gmail) for business", "Extra characters"],
    },
    {
      icon: Link,
      title: "Mismatched or Suspicious Links",
      description: "Hover over links before clicking. The displayed text often differs from the actual URL.",
      examples: ["URL shorteners", "IP addresses instead of domains", "Misspelled domains"],
    },
    {
      icon: FileWarning,
      title: "Unexpected Attachments",
      description: "Be wary of attachments you didn't expect, especially .exe, .zip, or macro-enabled Office files.",
      examples: [".exe files", "Password-protected zips", "\"Enable macros\" prompts"],
    },
    {
      icon: AlertTriangle,
      title: "Generic Greetings",
      description: "\"Dear Customer\" or \"Dear User\" instead of your name suggests mass-targeting.",
      examples: ["Dear Sir/Madam", "Dear Valued Customer", "Dear Account Holder"],
    },
    {
      icon: Lock,
      title: "Requests for Sensitive Info",
      description: "Legitimate companies never ask for passwords, SSNs, or full credit card numbers via email.",
      examples: ["Password reset via reply", "Payment info updates", "Personal verification"],
    },
  ];

  return (
    <section className="py-8 sm:py-12">
      <h2 className="text-2xl sm:text-3xl font-display font-bold text-foreground mb-6">
        Red Flags: How to Spot Phishing
      </h2>
      <p className="text-muted-foreground mb-8 max-w-3xl">
        Train yourself and your team to recognize these common phishing indicators.
      </p>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {redFlags.map((flag, index) => (
          <div
            key={index}
            className="bg-card rounded-xl border border-border p-6 hover:shadow-lg transition-shadow"
          >
            <div className="w-12 h-12 rounded-xl bg-destructive/10 flex items-center justify-center mb-4">
              <flag.icon className="w-6 h-6 text-destructive" />
            </div>
            <h3 className="text-lg font-semibold text-foreground mb-2">{flag.title}</h3>
            <p className="text-sm text-muted-foreground mb-4">{flag.description}</p>
            <div className="space-y-1">
              {flag.examples.map((example, i) => (
                <div key={i} className="text-xs text-foreground flex items-center gap-2">
                  <span className="w-1.5 h-1.5 rounded-full bg-destructive" />
                  {example}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
